
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.multicolumn-card');
  cards.forEach(function(card) {
    const link = card.querySelector('a[href]');
    if (link) {
      card.style.cursor = 'pointer';
      card.addEventListener('click', function(e) {
        if (!e.target.closest('a')) {
          window.location.href = link.href;
        }
      });
    }
  });
});
